import { useEffect, useRef } from "react";
import useIsIOS from "Hooks/useIsIos";
import browser from "browser-detect";

export const useIosPortal = (isNotApp) => {
  const isIos = useIsIOS();
  const redirectForIos = useRef({ done: false });

  useEffect(() => {
    let timer = 0;
    if (isIos && isNotApp && !redirectForIos.current?.done) {
      const href = window.location?.href;
      redirectForIos.current.done = true;
      const { name } = browser();
      const isSafari = name === "safari";
      if (typeof window !== "undefined" && !isSafari) {
        timer = setTimeout(async () => {
          const bundleId = "com.beetleware.investaseel";
          window.location.replace(`${bundleId}://${href}`);
          setTimeout(() => {
            const appstore = "itms-apps://apps.apple.com/app/id1622681127";
            window.location.replace(appstore);
          }, 3000);
        }, 1000);
      }
    }

    return () => window.clearTimeout(timer);
  }, [isIos, isNotApp]);
};
